(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    const rail = root.querySelector("[data-review-rail]");
    const cards = Array.from(root.querySelectorAll("[data-review-card]"));
    const prev = root.querySelector("[data-review-prev]");
    const next = root.querySelector("[data-review-next]");
    const progress = root.querySelector("[data-review-progress]");
    const modal = root.querySelector("[data-review-modal]");
    if (!rail || !cards.length) return;

    const step = () => cards[0].getBoundingClientRect().width + 16;
    const updateProgress = () => {
      const available = rail.scrollWidth - rail.clientWidth;
      const ratio = available <= 0 ? 1 : Math.min(1, Math.max(0, rail.scrollLeft / available));
      if (progress) progress.style.width = `${Math.max(12, ratio * 100)}%`;
    };

    prev?.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: "smooth" }));
    next?.addEventListener("click", () => rail.scrollBy({ left: step(), behavior: "smooth" }));
    rail.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress, { passive: true });

    const openModal = (card) => {
      if (!modal || typeof modal.showModal !== "function") return;
      const sourceImage = card.querySelector("img");
      const media = modal.querySelector("[data-modal-media]");
      media.replaceChildren();
      if (sourceImage) {
        const image = document.createElement("img");
        image.src = sourceImage.currentSrc || sourceImage.src;
        image.alt = sourceImage.alt;
        media.appendChild(image);
      }
      modal.querySelector("[data-modal-text]").textContent = card.querySelector(".evx-review__full")?.textContent.trim() || "";
      modal.querySelector("[data-modal-name]").textContent = card.querySelector(".evx-review__author strong")?.textContent.trim() || "";
      modal.querySelector("[data-modal-stars]").innerHTML = card.querySelector(".evx-review__stars")?.innerHTML || "★★★★★";
      modal.showModal();
      document.documentElement.style.overflow = "hidden";
    };

    cards.forEach((card) => card.querySelector(".evx-review__open")?.addEventListener("click", () => openModal(card)));
    modal?.querySelector("[data-review-close]")?.addEventListener("click", () => modal.close());
    modal?.addEventListener("click", (event) => {
      if (event.target === modal) modal.close();
    });
    modal?.addEventListener("close", () => { document.documentElement.style.overflow = ""; });
    updateProgress();
  };

  const initAll = (scope = document) => scope.querySelectorAll("[data-evemx-reviews]").forEach(init);
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => initAll()) : initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
